export default "__VITE_ASSET__TB5kN92U__"